import { ar } from "../components/common/i18n/ar";
import { da } from "../components/common/i18n/da";
import { de } from "../components/common/i18n/de";
import { es } from "../components/common/i18n/es";
import { fa } from "../components/common/i18n/fa";
import { fi } from "../components/common/i18n/fi";
import { fr } from "../components/common/i18n/fr";
import { hi } from "../components/common/i18n/hi";
import { he } from "../components/common/i18n/he";
import { gu } from "../components/common/i18n/gu";
import { as } from "../components/common/i18n/as";
import { id } from "../components/common/i18n/id";
import { it } from "../components/common/i18n/it";
import { ja } from "../components/common/i18n/ja";
import { kn } from "../components/common/i18n/kn";
import { ko } from "../components/common/i18n/ko";
import { ml } from "../components/common/i18n/ml";
import { mr } from "../components/common/i18n/mr";
import { ms } from "../components/common/i18n/ms";
import { ne } from "../components/common/i18n/ne";
import { nl } from "../components/common/i18n/nl";
import { or } from "../components/common/i18n/or";
import { pa } from "../components/common/i18n/pa";
import { pl } from "../components/common/i18n/pl";
import { pt } from "../components/common/i18n/pt";
import { pt_pt } from "../components/common/i18n/pt_pt";
import { ru } from "../components/common/i18n/ru";
import { sv } from "../components/common/i18n/sv";
import { ta } from "../components/common/i18n/ta";
import { te } from "../components/common/i18n/te";
import { tl } from "../components/common/i18n/tl";
import { tr } from "../components/common/i18n/tr";
import { uk } from "../components/common/i18n/uk";
import { ur } from "../components/common/i18n/ur";
import { vi } from "../components/common/i18n/vi";
import { zh_cn } from "../components/common/i18n/zh_cn";
import { zh_tw } from "../components/common/i18n/zh_tw";
import { en } from "../components/common/i18n/en";
import {bn} from "../components/common/i18n/bn";
import {ht} from "../components/common/i18n/ht";
import {ca} from "../components/common/i18n/ca";
import {az} from "../components/common/i18n/az";
import {my} from "../components/common/i18n/my";
import {th} from "../components/common/i18n/th";

const availableLanguagesObjects = 
 [
    { label: "عربي (Arabic)", key: "ar" },
    { label: "Deutsch (German)", key: "de" },
    { label: "English", key: "en" },
    { label: "Español (Spanish)", key: "es" },
    { label: "Française (French)", key: "fr" },
    { label: "Italian (It)", key: "it" },
    { label: "日本語 (Japanese)", key: "ja" },
    { label: "한국어 (Korean)", key: "ko" },
    { label: "हिंदी (Hindi)", key: "hi" },
    { label: "తెలుగు (Telugu)", key: "te" },
    { label: "தமிழ் (Tamil)", key: "ta" },
    { label: "मराठी (Marathi)", key: "mr" },
    { label: "অসমীয়া (Assamese)", key: "as" },
    { label: "বাংলা (Bangla)", key: "bn" },
    { label: "ગુજરાતી (Gujarathi)", key: "gu" },
    { label: "ಕನ್ನಡ (Kannada)", key: "kn" },
    { label: "മലയാളം (Malayalam)", key: "ml" },
    { label: "नेपाली (Nepali)", key: "ne" },
    { label: "ଓଡ଼ିଆ (Odia)", key: "or" },
    { label: "ਪੰਜਾਬੀ (Punjabi)", key: "pa" },
    { label: "Nederlands (Dutch)", key: "nl" },
    { label: "日本語 (Chinese)", key: "zh_cn" },
    { label: "עִברִית (Hebrew)", key: "he" },
    { label: "繁體中文 (Traditional Chinese)", key: "zh_tw" },
    { label: "Português (Portuguese - Brazil)", key: "pt" },
    { label: "Bahasa Indonesia (Indonesian)", key: "id" },
    { label: "Русский (Russian)", key: "ru" },
    { label: "Türkçe (Turkish)", key: "tr" },
    { label: "Tiếng Việt (Vietnamese)", key: "vi" },
    { label: "Polski (Polish)", key: "pl" },
    { label: "فارسی (Persian)", key: "fa" },
    { label: "اُردُو (Urdu)", key: "ur" },
    { label: "Haitian Creole (Ht)", key: "ht" },
    { label: "Tagalog (Tl)", key: "tl" },
    { label: "Finnish (Fi)", key: "fi" },
    { label: "Ukrainian (Uk)", key: "uk" },
    { label: "Swedish (Sv)", key: "sv" },
    { label: "Catalan (Ca)", key: "ca" },
    { label: "Azerbaijani (Az)", key: "az" },
    { label: "Danish (Da)", key: "da" },
    { label: "Malay (Ms)", key: "ms" },
    { label: "Myanmar (Burmese) (My)", key: "my" },
    { label: "Thai (Th)", key: "th" },
    { label: "Portuguese (European) (Pt_pt)", key: "pt_pt" }
  ]
  

class aai18nPlugin {
    name = 'aai18nPlugin';
    config = {
        rtlLanguages: ['ar'],
        availableLanguages:availableLanguagesObjects,//shown as list of available languages in chat window header to select
        defaultLanguage: "en",//default selection from above list
        languageStrings:{
            en:en,   //any additional language can be added in this object by adding the key in availableLanguages
            ar: ar,
            da: da,
            de: de,
            es: es,
            fa: fa,
            fi: fi,
            fr: fr,
            hi: hi,
            he: he,
            gu: gu,
            id: id,
            as: as,
            it: it,
            ja: ja,
            kn: kn,
            ko: ko,
            ml: ml,
            mr: mr,
            ms: ms,
            ne: ne,
            nl: nl,
            or: or,
            pa: pa,
            pl: pl,
            pt: pt,
            pt_pt: pt_pt,
            ru: ru,
            sv: sv,
            ta: ta,
            te: te,
            tl: tl,
            tr: tr,
            uk: uk,
            ur: ur,
            bn: bn,
            ht: ht,
            ca: ca,
            az: az,
            my: my,
            th: th,
            vi: vi,
            zh_cn: zh_cn,
            zh_tw: zh_tw,
        }
    }
}
export default aai18nPlugin;